module.exports = __webpack_public_path__ + "img/handeye_card.3583c6da.svg";